import { render, staticRenderFns } from "./Accelerometer.vue?vue&type=template&id=1dc23198&"
import script from "./Accelerometer.vue?vue&type=script&lang=js&"
export * from "./Accelerometer.vue?vue&type=script&lang=js&"
import style0 from "./Accelerometer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports